const Tactic = require('../../entities/Tactic');
const { Age }  = require("../Constants");
const TacticNames = require("../Names/TacticNames");

class PositionalArmy extends Tactic {
    constructor() {
        super(
            Age.Age3,
            TacticNames.PositionalArmy,
            [2, 0, 2],
            "12(6)",
            {}
        )
    }
}

module.exports = PositionalArmy;